<template>
  <div class="card card-personel h-100">
    <div class="HeaderPersonel text-light">
      <div class="User-Icon">
        <slot name="cardbox-icon1"> </slot>
      </div>
      <div class="User-Icon">
        <slot name="cardbox-icon2"> </slot>
      </div>

      <b-dropdown size="md" variant="link" class="d-inline float-left btn-more text-center" toggle-class="text-decoration-none " no-caret>
        <template #button-content
          ><h4><i class="fad fa-ellipsis-v text-dark"></i></h4
        ></template>
        <slot name="b-dropdown-item"> </slot>
      </b-dropdown>
    </div>

    <div class="card-body text-center">
      <slot name="cardbox-body"> </slot>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
}
</script>
<style>
.card {
  /* background: var(--sidebar-action-bg) !important; */
  -webkit-box-shadow: 5px 5px 13px 3px rgba(84, 95, 97, 0.1);
  box-shadow: 5px 5px 13px 3px rgba(84, 95, 97, 0.1);
}
.HeaderPersonel {
  width: 100% !important;
  height: 100px !important;
  background: var(--sidebar-action-bg);
  position: relative;
  text-align: center;
}
.User-Icon {
  width: 80px;
  height: 80px;
  border-radius: 100%;
  font-size: 50px;
  padding: 2%;
  /* background: var(--sidebar-action-bg); */
  position: absolute;
  bottom: 10px;
  right: 32%;
  text-align: center;
}
.User-Icon i {
  color: var(--sidebar-color-item) !important;
}
.btn-more {
  position: absolute;
  top: 10px;
  left: 0;
}
.card-personel {
  background: var(--sidebar-bg-color);
  /* color:var(--sidebar-color-item); */
  border-radius: 8px;
  overflow: hidden;
}
.detail {
  font-size: 13px;
}
</style>
